import { useCurrentModule } from '../components/ModuleProvider';
import { extractNumericRate } from '../utils/extractNumericRate';
import { STUDIO_CURRENT_PLAN_BG_COLOR, STUDIO_RECOMMENDED_BG_COLOR, STUDIO_SALE_BG_COLOR } from '../utils/consts';
import { useIsSeasonalSale } from './useIsSeasonalSale';
export const useProductHat = _ref => {
  var _discountData$discoun;
  let {
    productId
  } = _ref;
  const module = useCurrentModule();
  const {
    data: product
  } = module.SDK.studioOfferingApiClient.hooks.useFetchProduct({
    productId
  });
  const {
    t
  } = module.internals.useTranslations();
  const {
    recommendedDisplayText,
    isRecommended,
    hasSale
  } = product ?? {};
  const {
    data: {
      isCurrentProduct
    } = {
      isCurrentProduct: false
    }
  } = module.SDK.switchApiClient.hooks.useIsCurrentProduct({
    productId
  });
  const isSeasonalSale = useIsSeasonalSale();
  const {
    data: discountData
  } = module.SDK.studioOfferingApiClient.hooks.useFetchOfferingDiscount({});
  if (isCurrentProduct) {
    return {
      text: t('premium-purchase-plan.cards.hat.current_plan'),
      background: STUDIO_CURRENT_PLAN_BG_COLOR,
      hasHat: true
    };
  }
  if (isSeasonalSale && hasSale && discountData != null && (_discountData$discoun = discountData.discount) != null && _discountData$discoun.rate) {
    const numericRate = extractNumericRate(discountData.discount.rate);
    return {
      // Reuse the Eclipse coupon-label key so the hat text stays in sync
      // with the checkout coupon label (both render "{percent}% OFF").
      text: t('sale.product.x_off', {
        percent: numericRate
      }),
      background: STUDIO_SALE_BG_COLOR,
      hasHat: true
    };
  }
  if (isRecommended) {
    return {
      text: recommendedDisplayText == null ? void 0 : recommendedDisplayText.toUpperCase(),
      background: STUDIO_RECOMMENDED_BG_COLOR,
      hasHat: true
    };
  }
  return {
    text: undefined,
    background: undefined,
    hasHat: false
  };
};
//# sourceMappingURL=useProductHat.js.map